/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';

const WallModel = () => {    
    const { gl } = useThree ();

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const offsetWithDoorThickness = 0.127;
    const railWidth = 0.2;

    let offset;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false    
   
    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanF_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosOffset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - 0.2) return railWidth;
        else return 0;
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])

    // Storage Front Wall - CSG
     const storageFrontWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;
        
        //************************* */ main wall geometry
        let verticalHorizontalPosStorageF ={"x": params.leanF_p_d /-2 + parseInt(params.add_storage_front) + 0.01,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.p_d / 2 + params.leanF_p_w + 0.12}
        let verticalHorizontalRotStorageF = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLengthStorageF = params.leanF_p_h + ((params.b_l_t_r_pF / 12) * (params.leanF_p_w)) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0);
        let patternDepthStorageF = params.leanF_p_w
     
        const backStorageWallModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            backStorageWallModel.moveTo(-(params.leanF_p_w), 0);
            backStorageWallModel.lineTo(-(params.leanF_p_w), params.leanF_p_h);
            backStorageWallModel.lineTo(-(params.leanF_p_w), params.leanF_p_h + const_var.roofRegularDst);
            backStorageWallModel.quadraticCurveTo(-(params.leanF_p_w), params.leanF_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, 
                                            -(params.leanF_p_w - const_var.roofRegularDst + 0.1), params.leanF_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pF / 12))
            backStorageWallModel.lineTo(0, params.leanF_p_h + ((params.b_l_t_r_pF / 12) * (params.leanF_p_w) + const_var.roofRegularDst * (2)));
            backStorageWallModel.lineTo(0, 0);
            backStorageWallModel.closePath();
        } else {
            backStorageWallModel.moveTo(-params.leanF_p_w + offsetWithDoorThickness - 0.12, params.leanF_p_h);
            backStorageWallModel.lineTo(0, params.leanF_p_h + params.leanF_p_w / 12 * params.b_l_t_r_pF);
            backStorageWallModel.lineTo(0, 0);
            backStorageWallModel.lineTo(-params.leanF_p_w + offsetWithDoorThickness - 0.12, 0);
            backStorageWallModel.closePath();
        }
                
        const meshStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageF, isPattern), extrudeSettings(patternDepthStorageF)))  
        const meshFrontStorageWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backStorageWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backStorageWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let meshStorageWallModel_Temp = meshStorageWallModel.clone();
        meshStorageWallModel_Temp.position.set(verticalHorizontalPosStorageF.x,verticalHorizontalPosStorageF.y,verticalHorizontalPosStorageF.z);
        meshStorageWallModel_Temp.rotation.set(verticalHorizontalRotStorageF.x,verticalHorizontalRotStorageF.y,verticalHorizontalRotStorageF.z);
        meshStorageWallModel_Temp.updateMatrixWorld();
    
        let meshFrontStorageWallModel_Temp = meshFrontStorageWallModel.clone();
        meshFrontStorageWallModel_Temp.rotateY(Math.PI / 2);
        meshFrontStorageWallModel_Temp.position.set(-params.leanF_p_d / 2 + parseInt(params.add_storage_front) - 0.5, 0, params.p_d / 2 + cbFrontBackWallOffset)
        meshFrontStorageWallModel_Temp.updateMatrixWorld();
        
        let meshFrontStorageInnerWallModel_Temp = meshFrontStorageInnerWallModel.clone();
        meshFrontStorageInnerWallModel_Temp.rotateY(Math.PI / 2);
        meshFrontStorageInnerWallModel_Temp.position.set(-params.leanF_p_d / 2 + parseInt(params.add_storage_front), 0, params.p_d / 2 + cbFrontBackWallOffset)
        meshFrontStorageInnerWallModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.rotateY(Math.PI / 2)
        meshFrontStorageDelModel_Temp.position.set( parseInt(params.add_storage_front) - 0.5 -params.leanF_p_d / 2, 0, 0);
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, params.p_d / 2 + params.leanF_p_w - 0.05);
        meshSideDelModel_Temp.updateMatrixWorld();
    
        const meshFrontStorageWallModel_CSG = CSG.fromMesh(meshFrontStorageWallModel_Temp);
        const meshFrontStorageInnerWallModel_CSG = CSG.fromMesh(meshFrontStorageInnerWallModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshStorageWallModel_CSG = CSG.fromMesh(meshStorageWallModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
    
        const frontStorageWallModel_CSG =  meshFrontStorageWallModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const storageWallModel_CSG = meshStorageWallModel_CSG.intersect(frontStorageWallModel_CSG);
        const sideOuterDelModel_CSG = storageWallModel_CSG.subtract(meshSideDelModel_CSG);

        const frontStorageInnerWallModel_CSG =  meshFrontStorageInnerWallModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const sideInnerDelModel_CSG =  frontStorageInnerWallModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGFrontStorageWallModel = CSG.toMesh( sideOuterDelModel_CSG,new THREE.Matrix4(),new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGFrontStorageInnerWallModel = CSG.toMesh( sideInnerDelModel_CSG,new THREE.Matrix4(),new THREE.MeshStandardMaterial({ color: 'blue' }))

        mainWall = CSGFrontStorageWallModel.geometry
        innerWall = CSGFrontStorageInnerWallModel.geometry
        
        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosStorageF = {"x": params.leanF_p_d /-2 + parseInt(params.add_storage_front) + 0.01,"y" : 0, "z" : params.p_d / 2 + params.leanF_p_w + 0.12}
        let wainscotVerticalHorizontalRotStorageF = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPatternStorageF = 3
        let depthPatternStorageF = patternDepthStorageF - 0.04

        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageF, isPattern), extrudeSettings(depthPatternStorageF)))
        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageF.x,wainscotVerticalHorizontalPosStorageF.y,wainscotVerticalHorizontalPosStorageF.z);
        meshStorageFrontWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageF.x,wainscotVerticalHorizontalRotStorageF.y,wainscotVerticalHorizontalRotStorageF.z);
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);

        const storageFrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const meshSideWainscotDelModel_CSG = storageFrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(
            meshSideWainscotDelModel_CSG,
            new THREE.Matrix4()
        )

        wainscotWall = CSGStorageFrontWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}
    }, [params.wallTexture,params.p_d, params.p_r_s, params.leanF_p_w, params.leanF_p_d, params.frontLeanStoragePosition, params.leanF_p_h, params.b_l_t_r_pF, params.p_b_c_b_f_b, params.p_v_w, params.add_storage_front, const_var.newDoorsArray, params.add_storage_check_front, params.leanF_p_pos, params.p_w_c_n])

    return (
        <group position={[wallPosOffset, 0, 0]}>
            {storageFrontWallModelObj?.mainWall &&
                    <mesh name="F_L_R_S_W" geometry={storageFrontWallModelObj?.mainWall} position={[offset + 0.02, 0, 0]} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"frontLean"} />
                    </mesh>
            }
            {storageFrontWallModelObj?.innerWall&&
                    <mesh name="storage" geometry={storageFrontWallModelObj?.innerWall} position={[-wallThickness + offset - 0.01, 0, 0]}>
                        <MaterialInnerWall texture={texture} visibleSection={"frontLean"} />
                    </mesh>
            }
            {/* Storage Front Wainscot */}
            {params.p_w_c_n === true && params.add_storage_check_front && storageFrontWallModelObj?.wainscotWall &&
                <mesh name="F_L_R_S_W_wainscot" geometry={storageFrontWallModelObj?.wainscotWall} position={[0.025 + offset,0,0]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"frontLean"} />
                </mesh>
            }
        </group>
    )
}

export default WallModel